import React, { useState } from "react";
import './style.css'
import Papa from "papaparse";
import NormalButton from "../commons/NormalButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import ImportMarcaInfoStep2 from "../shortDescs/ImportMarcaInfoStep2";
import ImportColumnSelector from "../ImportColumnSelector";
import { addMarcasByCsvDataApi } from "../../apis/importApis";
import { useDispatch } from 'react-redux';
import { setIsLoading } from '../../redux/navbar';
import {pad_with_zeroes, removeSpecialCharacters} from './../../actions/commons'
 
// Allowed extensions for input file
const allowedExtensions = ["csv"];
 
const ImportDataMarca = ({ history }) => {

    const dispatch = useDispatch();

    const [error, setError] = useState("");
    const [file, setFile] = useState("");
    const [step, setStep] = useState(1);
    const [fileHeaders, setFileHeaders] = useState([]);
    const [fileData, setFileData] = useState(null);

    const [idFieldName, setIdFieldName] = useState('');
    const [descFieldName, setDescFieldName] = useState('');
    const [dataWithProblem, setDataWithProblem] = useState([]);
    const [successCount, setSuccessCount] = useState(0);
    const [failureCount, setFailureCount] = useState(0);

    let storeName = localStorage.getItem("storeName");
	let storeId = localStorage.getItem("storeId"); 
	let username = localStorage.getItem("username"); 

 
    const handleFileChange = (e) => {
        setError("");
         
        // Check if user has entered the file
        if (e.target.files.length) {
            const inputFile = e.target.files[0];
             
            // Check the file extensions, if it not
            // included in the allowed extensions
            // we show the error
            const fileExtension = inputFile?.type.split("/")[1];
            if (!allowedExtensions.includes(fileExtension)) {
                setError("Por favor escolha uma aquivo com extensão .csv");
                return;
            }
 
            // If input type is correct set the state
            setFile(inputFile);
        }
    };
    const handleParse = () => {
         
        // If user clicks the parse button without
        // a file we show a error
        if (!file) return setError("Escolha um arquivo .csv válido.");
 
        // Initialize a reader which allows user
        // to read any file or blob.
        const reader = new FileReader();
         
        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({ target }) => {
            const csv = Papa.parse(target.result, { header: true });
            const parsedData = csv?.data;
            if(parsedData.length<2) setError("Por favor selecione um arquivo que tenha pelo menos um item.");
            else{
                const columns = Object.keys(parsedData[0]);
                if(columns.length<2) setError("Por favor selecione um arquivo que tenha pelo menos duas colunas.");
                else{
                    setFileData(parsedData);
                    setFileHeaders(columns);
                    setStep(2);
                }
            }
        };
        reader.readAsText(file);
    };

    const uploadData = async () => {

        if(!idFieldName || !descFieldName){
            alert("Selecione os campos necessários");
            return;
        }

        let dataToUpload = [];
        
        fileData.forEach(tempRec=>{
            dataToUpload.push({
                'sp_id' :  tempRec[idFieldName],
                'description' :  removeSpecialCharacters(tempRec[descFieldName]),
            })
        })
        
        dispatch(setIsLoading(true));

        await addMarcasByCsvDataApi(dataToUpload).then(res=>{
            if(res.data.status==="success"){
                setDataWithProblem(res.data.dataWithProblem);
                setSuccessCount(res.data.successCount);
                setFailureCount(res.data.failureCount);
                setStep(3);

            }else{
                setError(res.data.message);
            }
        }).catch(err=>console.log(err));

        dispatch(setIsLoading(false));

    }

    const changeLevel = () => {
        if(step === 1){
            handleParse();
        }else if(step === 2){
            uploadData();
        }
    }
 
    return (
        <div className="ImportDataMarca">

            <div className="ImportDataMarca-header">
                <h3>Importação de Marcas</h3>
            </div>

            {(!!storeName || !!storeId || !!username) && <>
				<div className="ImportInfo-header-details">
					{!!storeId && <><h3>LOJA: {pad_with_zeroes(storeId)}</h3></>}
					{!!storeName && <><h3>NOME: {storeName}</h3></>}
					{!!username && <><h3>USUÁRIO: {username}</h3></>}
				</div>
			</>}

            <div className="ImportDataMarca-container">

                {step === 1 && <>
                    <ImportMarcaInfoStep2 />
                    <div className="ImportDataMarca-step2-button-div">
                        <label htmlFor="ImportDataMarca-csvInput" id="ImportDataMarca-csvInputLabel">
                            <FontAwesomeIcon icon={faFileCsv} />
                        </label>
                        <h5>{!!file && <>{file.name}</>}</h5>
                    </div>
                    <input
                        onChange={handleFileChange}
                        id="ImportDataMarca-csvInput"
                        name="file"
                        type="File"
                    />
                </>}

                {step === 2 && <>
                    <h5 className="ImportDataMarca-local-text">Agora você deve indicar qual coluna da sua planilha .CSV deve ser importada para cada campo do TicTag.</h5>
                    <div>
                        <ImportColumnSelector 
                            columnLabel="ID"
                            selectOptions={fileHeaders.filter(col=>!!col).map(col=>{return{label:col,value:col}})}
                            selectedValue={idFieldName}
                            onChange={e=>{setIdFieldName(e.target.value)}}
                            exapleLabel={!!idFieldName ? fileData[0][idFieldName] : "---------"}
                        />
                        <ImportColumnSelector 
                            columnLabel="DESCRIÇÃO"
                            selectOptions={fileHeaders.filter(col=>!!col).map(col=>{return{label:col,value:col}})}
                            selectedValue={descFieldName}
                            onChange={e=>{setDescFieldName(e.target.value)}}
                            exapleLabel={!!descFieldName ? fileData[0][descFieldName] : "---------"}
                        />
                    </div>
                </>}

                {step === 3 && <>
                    <div className="ImportDataMarca-result-box">
                        <div className="ImportDataMarca-result-box-left">
                            <div className="ImportDataMarca-result-box-left-c1">
                                <h5 className="ImportDataMarca-result-box-left-c1-t1">Itens importados com sucesso</h5>
                                <h5 className="ImportDataMarca-result-box-left-c1-t2">{successCount}</h5>
                            </div>
                            <div className="ImportDataMarca-result-box-left-c1">
                                <h5 className="ImportDataMarca-result-box-left-c1-t1 text-danger">Itens não importados</h5>
                                <h5 className="ImportDataMarca-result-box-left-c1-t2 btn-danger">{failureCount}</h5>
                            </div>
                        </div>
                        <div className="ImportDataMarca-result-box-right">
                            <NormalButton label="CARREGAR NOVAMENTE" classNames="ImportDataMarca-finish-button" 
                                onClick={() => {
                                    // history.push('/home/import-data/marcas/');
                                    window.location.href = '/home/import-data/MARCAS/';
                                }} 
                            />
                            <NormalButton label="IMPORTAR TAMANHOS" classNames="ImportDataMarca-finish-button" 
                                onClick={() => {
                                    // history.push('/home/import-data/marcas/');
                                    window.location.href = '/home/import-data/TAMANHOS/';
                                }} 
                            />
                        </div>
                    </div>
                    <table className="ImportDataMarca-results-table">
                        <thead className="">
                            <tr>
                                <td>ID</td>
                                <td>OBSERVAÇÕES</td>
                            </tr>
                        </thead>
                        <tbody>
                            {dataWithProblem.map((tempSpId, i)=><>
                                <tr key={i}>
                                    <td>{tempSpId[0]}</td>
                                    <td className="text-danger">{tempSpId[1]}</td>
                                </tr>
                            </>)}
                        </tbody>
                    </table>
                </>}

                {!!error && <><h5 className="ImportDataMarca-error">{error}</h5></>}
            </div>


            <div className="ImportDataMarca-footer">
                {(step===1) && <>
                    <NormalButton label="SKIP" classNames="ImportDataMarca-footer-button ImportDataMarca-footer-button-warning" 
                        onClick={() => {
                            // history.push('/home/import-data/marcas/');
                            window.location.href = '/home/import-data/TAMANHOS/';
                        }} 
                    />
                </>}
                {(step !== 3) && <>
                    <NormalButton label="PRÓXIMA ETAPA"  classNames="ImportDataMarca-footer-button" onClick={changeLevel} />
                </>}
            </div>
            
        </div>
    );
};

export default ImportDataMarca;